import React from 'react';
import { RailsThumbnailItem } from '@sls-react/typings/services/rails/item';
import ItemThumbnail from '@sls-react/components/ItemThumbnail/ItemThumbnail';
import useMobile from '@sls-react/hooks/useMobile';
import { useWindowSize } from 'react-use';
import MobileOnlyFeatheredOverflowContainer from '@sls-react/components/MobileOnlyFeatheredOverflowContainer';
import FeatheredOverflowContainer from '@sls-react/components/FeatheredOverflowContainer';

interface Props {}

/**
 * Displays a horizontal scroll of items in mobile, but an item grid in desktop
 */
const HorizontalScrollItemGrid: React.FC<Props> = ({ children }) => (
  <FeatheredOverflowContainer
    className="items-stretch space-x-2"
    css={`
      padding-left: 0.5px;
      padding-bottom: 0.5px;
    `}
  >
    {children}
  </FeatheredOverflowContainer>
);

export default HorizontalScrollItemGrid;
